import { X } from "lucide-react";
import { forwardRef } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Badge } from "~/components/ui/badge";

const messages = defineMessages({
  documents: { id: "search.documents", defaultMessage: "Documents" },
  cases: { id: "search.cases", defaultMessage: "Cases" },
});

type TypeHeaderProps = {
  activeBadge: string;
  type: keyof typeof messages;
  clearType: () => void;
};

export const TypeHeader = forwardRef<HTMLDivElement, TypeHeaderProps>(
  ({ activeBadge, clearType, type }, ref) => {
    const intl = useIntl();
    return (
      <div className="flex pt-3 px-1" ref={ref}>
        {activeBadge === "all" ? (
          <span className="text-muted-foreground text-sm font-medium">
            {intl.formatMessage(messages[type])}
          </span>
        ) : (
          <Badge
            className="flex gap-1 items-center cursor-pointer bg-blue-600 hover:bg-blue-700 self-start border-none rounded-full pr-1.5"
            onClick={clearType}
          >
            {intl.formatMessage(messages[type])}
            <X className="h-3 w-3" />
          </Badge>
        )}
      </div>
    );
  }
);
